/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";

import Stack from "@mui/material/Stack";
import { Button, Typography } from "@mui/material";
import { Card, CardContent } from "@mui/material";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";
import Loader from "@jumbo/components/Loader";
import { userType } from "app/helpers/userType";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { getDebitNoteList } from "app/redux/slice/debitNoteSlice";
import moment from "moment";

const DebitNoteList = () => {
  const { id } = useParams();
  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  const { isMA } = userType();
  const navigate = useNavigate();

  const debitNoteData = useSelector((state) => state?.debitNote);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "uniqueVariant" });

  const columns = [
    { id: "billDebitNo", label: "Bill Debit No", sort: true },
    {
      id: "date",
      label: "Date",
      sort: true,
      render: (row) =>
        row?.date ? moment(row?.date).format("DD-MM-YYYY") : "",
    },
    { id: "total", label: "Total", sort: true },
    { id: "remark", label: "Remark", sort: true },
    // {
    //   id: "tags",
    //   label: "Tags",
    //   render: (row) => row?.tags?.join(", "),
    // },
  ];

  const getData = () => {
    const value = {
      page: page,
      perPage: rowsPerPage,
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getDebitNoteList({ id, data: value }));
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    if (id) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, dispatch, order, orderBy, id]);

  return (
    <>
      {debitNoteData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Debit Note List
                </Typography>
              </Stack>
              <Table
                columns={columns}
                rows={debitNoteData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={debitNoteData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default DebitNoteList;
